import { render, staticRenderFns } from "./ProcedimentosRequisicao.vue?vue&type=template&id=a94c0796&"
import script from "./ProcedimentosRequisicao.vue?vue&type=script&lang=js&"
export * from "./ProcedimentosRequisicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports